import IconErrorOutline from "@mui/icons-material/ErrorOutline";
import { FailureApi } from "@smp/api";
import { UiCardUncustomized, UiTypography } from "@smp/ui";
import { useMemo } from "react";

import { useFailureTranslator } from "@/hooks/use_failure_translator";

import { useStyles } from "./card_failure.css";

export const CardFailure = ({ clause }: { clause: unknown }) => {
  const { failureTranslationGet } = useFailureTranslator();
  const classes = useStyles();

  const message = useMemo(
    () => failureTranslationGet(clause),
    [clause, failureTranslationGet],
  );

  return useMemo(() => {
    const failures = clause instanceof FailureApi ? clause.failures : undefined;

    const hasFailures = !!(failures && !!Object.keys(failures).length);

    return (
      <UiCardUncustomized className={classes.card}>
        <div className={classes.title}>
          <IconErrorOutline className={classes.icon} />
          <UiTypography className={classes.textTitle}>{message}</UiTypography>
        </div>
        {hasFailures && (
          <div className={classes.description}>
            {Object.keys(failures).map((key, idx) => (
              <UiTypography className={classes.textDescription} key={idx}>
                {key}:{" "}
                {failureTranslationGet(failures[key]) || "FAILURE MESSAGE"}
              </UiTypography>
            ))}
          </div>
        )}
      </UiCardUncustomized>
    );
  }, [
    classes.card,
    classes.description,
    classes.icon,
    classes.textDescription,
    classes.textTitle,
    classes.title,
    clause,
    failureTranslationGet,
    message,
  ]);
};
